'use strict';

import { id } from '../utils/id';

export function RepeatableFieldset(params) {

    let repeatedFieldsetElements = new Array();
    const fieldsetElement = params.fieldsetElement;
    const ctaElement = params.ctaElement;
    const deleteFieldsetCtaSelector = params.deleteFieldsetCtaSelector;
    const deleteFieldsetCtaElement = fieldsetElement.querySelector(deleteFieldsetCtaSelector);

    const onRepeatCallback = (params.onRepeatCallback && typeof params.onRepeatCallback === 'function') ? params.onRepeatCallback : null;
    const onDeleteCallback = (params.onDeleteCallback && typeof params.onDeleteCallback === 'function') ? params.onDeleteCallback : null;

    if (!fieldsetElement.hasAttribute('data-repeatable-fieldset')) {
        fieldsetElement.setAttribute('data-repeatable-fieldset', '');
    }

    if(deleteFieldsetCtaElement) {
        deleteFieldsetCtaElement.addEventListener('click', function (event) {
            event.preventDefault();
            fieldsetElement.style.display = 'none';
            fieldsetElement.setAttribute('disabled', true);

            const elements = fieldsetElement.querySelectorAll('input, select, textarea');

            for (let i = 0; i < elements.length; ++i) {
                if (typeof elements[i].value !== 'undefined' && elements[i].type !== 'radio' && elements[i].type !== 'checkbox') {
                    elements[i].value = null;
                }
            }

            if (onDeleteCallback) {
                onDeleteCallback(fieldsetElement);
            }
        });
    }

    function newRepeatedFieldsetElement(fieldsetElement, index, deleteElement) {
        const clonedFieldsetElement = fieldsetElement.cloneNode(true);

        if (clonedFieldsetElement.hasAttribute('id')) {
            clonedFieldsetElement.removeAttribute('id');
        }

        if (clonedFieldsetElement.hasAttribute('data-repeatable-fieldset')) {
            clonedFieldsetElement.removeAttribute('data-repeatable-fieldset');
        }

        if (clonedFieldsetElement.style.getPropertyValue('display') === 'none') {
            clonedFieldsetElement.style.removeProperty('display');
        }

        if (clonedFieldsetElement.hasAttribute('disabled')) {
            clonedFieldsetElement.removeAttribute('disabled');
        }

        const elements = clonedFieldsetElement.querySelectorAll('label, input, select, textarea');

        /* DANGER */
		function isInsideRepeaterFieldset(node) {
			if (!node.parentNode || node.parentNode == fieldsetElement) return false;

			if (node.parentNode.dataset && (node.parentNode.dataset.repeatableFieldset !== undefined || node.parentNode.dataset.repeatedFieldset !== undefined)) {
				return true;
			}

			return isInsideRepeaterFieldset(node.parentNode);
		};

        for (let i = 0; i < elements.length; ++i) {

            if(!isInsideRepeaterFieldset(elements[i])) {
                if (elements[i].hasAttribute('id')) {
                    elements[i].id = elements[i].id + '-' + index;
                }

                if (elements[i].hasAttribute('for')) {
                    elements[i].setAttribute('for', elements[i].getAttribute('for') + '-' + index);
                }

                if (elements[i].hasAttribute('name')) {
                    elements[i].setAttribute('name', elements[i].getAttribute('name') + '-' + index);
                }

                if (typeof elements[i].value !== 'undefined' && elements[i].type !== 'radio' && elements[i].type !== 'checkbox') {
                    elements[i].value = null;
                }
    
                if (elements[i].checked) {
                    elements[i].checked = false;
                }
            }
        }

        clonedFieldsetElement.setAttribute('data-repeated-fieldset', index);

        const deleteClonedFieldsetCtaElement = clonedFieldsetElement.querySelector(deleteFieldsetCtaSelector);

        if(deleteClonedFieldsetCtaElement) {
            if(deleteClonedFieldsetCtaElement.style.display == 'none') deleteClonedFieldsetCtaElement.style.display = '';

            deleteClonedFieldsetCtaElement.addEventListener('click', function (event) {
                event.preventDefault();
                deleteElement(index);
            });
        }

        const elementsToRemove = clonedFieldsetElement.querySelectorAll('[data-remove-from-repeated-fieldset], .form__error-alert');
        
        for (let i = 0; i < elementsToRemove.length; ++i) {
            elementsToRemove[i].parentNode.removeChild(elementsToRemove[i]);
        }

        const elementsWithErrorClassToRemove = clonedFieldsetElement.querySelectorAll('[class*="--invalid"');
        for (let i = 0; i < elementsWithErrorClassToRemove.length; ++i) {
            const classes = elementsWithErrorClassToRemove[i].className.split(' ');

            for (let j = 0; j < classes.length; ++j) {
                if(classes[j].endsWith('--invalid')) {
                    elementsWithErrorClassToRemove[i].classList.remove(classes[j]);
                }
            }
        }

        return clonedFieldsetElement;
    }

    function addRepeatedFieldsetElements(addedFieldsetElements) {
        for (let i = 0; i < addedFieldsetElements.length; ++i) {
            const addedFieldsetElement = addedFieldsetElements[i];
            repeatedFieldsetElements.push(addedFieldsetElement);

            const deleteAddedFieldsetCtaElement = addedFieldsetElement.querySelector(deleteFieldsetCtaSelector);

            if(deleteAddedFieldsetCtaElement) {
                deleteAddedFieldsetCtaElement.addEventListener('click', function (event) {
                    event.preventDefault();

                    repeatedFieldsetElements = repeatedFieldsetElements.filter(function (element) {
                        if (element.dataset.repeatedFieldset == addedFieldsetElement.dataset.repeatedFieldset) {
                            element.parentNode.removeChild(element);

                            if (onDeleteCallback) {
                                onDeleteCallback(element);
                            }
                        } else {
                            return element;
                        }
                    });
                });
            }
        }
    }

    if (ctaElement) {
        ctaElement.addEventListener('click', function (event) {
            event.preventDefault();

            if (repeatedFieldsetElements.length === 0 && fieldsetElement.style.display === 'none') {
                fieldsetElement.style.display = '';
                fieldsetElement.removeAttribute('disabled');

                if (onRepeatCallback) {
                    onRepeatCallback(fieldsetElement);
                }
            } else {
                const repeatedFieldsetElement = newRepeatedFieldsetElement(
                    fieldsetElement,
                    id(),
                    function (index) {
                        repeatedFieldsetElements = repeatedFieldsetElements.filter(function (element) {
                            if (element.dataset.repeatedFieldset == index) {
                                fieldsetElement.parentNode.removeChild(element);

                                if (onDeleteCallback) {
                                    onDeleteCallback(element);
                                }
                            } else {
                                return element;
                            }
                        });
                    });

                fieldsetElement.parentNode.insertBefore(repeatedFieldsetElement, repeatedFieldsetElements.length ? repeatedFieldsetElements[repeatedFieldsetElements.length - 1].nextSibling : fieldsetElement.nextSibling);
                repeatedFieldsetElements[repeatedFieldsetElements.length] = repeatedFieldsetElement;

                if (onRepeatCallback) {
                    onRepeatCallback(repeatedFieldsetElement);
                }
            }
        })
    }

    return {
        addRepeatedFieldsetElements: addRepeatedFieldsetElements
    }
}